<template>
  <div class="main">
    <span class="main-config">
      <div v-if="!readOnly" class="ml-2 mr-2 mb-2 mt-2">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form v-if="operationSelected && equipments.length > 1" class="b-layout">
      <b-card>
        <div v-for="(prop, index) in equipments" :key="prop.caption + index">
          <b-form-checkbox
            class="switch-item"
            v-model="prop.value"
            @change="ChangeOnOff($event, prop)"
            switch
            >
            {{ prop.equipName }}
            </b-form-checkbox>
        </div>
      </b-card>
      <div class="ml-3">
        <b-card>
          <div class="inp">
            <label>{{ $t('cap-vol-m-h') }} </label>
            <label>{{ CapacidadeVol.value | ParseNumber }}</label>
          </div>
          <div class="inp">
            <label>{{ $t('ocupacao-1') }} </label>
            <label>{{ Ocupacao.value | ParseNumber }}</label>
          </div>
          <div class="inp">
            <label>{{ $t('temp-bulbo-umido-c') }} </label>
            <label>{{ TBU.value | ParseNumber }}</label>
          </div>
        </b-card>
      </div>
    </b-form>
    </span>
    <div v-if="jokerEquipmentList.length" class="joker">
      <label class="mt-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput 
              :text="joker.caption"
              @sendText="updateCaption($event, joker)">
            </TextToInput>
          </div>
          <span class="b-layout">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                <b-form-checkbox
                      class="switch-item"
                      v-model="prop.value"
                      @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                      switch
                      >
                      {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp mb-2">
                  <label>{{ $t('cap-vol-m-h-0') }} </label>
                  <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-0') }} </label>
                  <label class="input-data">{{ joker.Ocupacao.value | ParseNumber }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from '../../../mixins/jokerEquipmentsMixin'
import TextToInput from "../../../template/TextToInput"
import { FiltersMixin }  from '../../../mixins/filtersMixin'

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  components: { TextToInput },

  mixins: [ JokerEquipmentMixin, FiltersMixin ],


  data() {
    return {
      operations: [{ value: null, text:this.$t('selecione-uma-operacao') }],
      operationAttributeList: [],
      operationSelected: null,
      firstLoad: false,
      attrList: ["CapacidadeVol", "Ocupacao", "CalcRefluxo", "TBU"],
      CapacidadeVol: {},
      Ocupacao: {},
      TBU: {},
      equipments: [],
      equipCap: [],
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad || !value) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();
      this.buildJokerEquipment(value)


      this.operationAttributeList = SingletonEnginnering.getOperationsProperties(
        this.operationSelected
      ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );

        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
      this.updateNode();
    },

    "CapacidadeVol.value"() {
      this.updateNode();
    },
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
        this.buildJokerEquipment(this.node.data[0].index, this.node.jokerCaption)
      }
      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }

        if (p.equipName) {
          let result = ParseToNumber(p.value) ? true : false;
          p.value = result;
          this.equipments.push(p);
        }
      });
      this.loadEquipments();
    },

    updateNode() {
      let attrs = [this.Ocupacao.clone(), this.CapacidadeVol.clone(), this.TBU.clone()];

      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? '1,00' : '0,00';
        attrs.push(prop);
      });
      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList)
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }
          if (props[p].caption == "Capacidade") {
            if (props[p].strValue != "") {
              props[p].value = props[p].strValue;
            }
            this.equipCap.push(props[p]);
          }
        });
      });

      this.equipments = auxEquipment;
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacidade();
      this.switchStatusJoker(prop, this.equipments, false, this.Changecapacidade)
      this.updateNode();
    },

    ChangeCapacidade() {
      if (this.CapacidadeVol) {
        this.CapacidadeVol.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          let isTrue = JSON.parse(e.value);
          if (isTrue && cap)
            this.CapacidadeVol.value += parseFloat(
              String(cap.value).replace(",", ".")
            );
        });
      }
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/ECT/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacidade();
    this.changeExternalCapacity = function () { this.ChangeCapacidade() }
    this.updataNodeInMixin = function () { this.updateNode() }
  },
};
</script>

<style scoped>
form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
}

.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.main{
  display: flex;
}

.main-config{
  width: 400px;
}
</style>
